import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import userProgressMixin from '../../mixins/_user_progress';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import modalReservationDatetimeEditor from '../../components/deploy/_modal_reservation_datetime_editor';

/**
 * 保存、反映のコンポーネント
 */
export default {
    template: '#deploy_btns_component_template',
    data() {
        return {
            // 指定エリアのみの反映か否かフラグ
            area_only: false,
            // 貼り付けエリア毎html
            area_htmls: [],
            // 貼り付け場所指定エリア
            active_tab_area: null,
            // 反映フラグ
            should_publish: true,
            // 反映予約時刻
            reserve_time: null,
        };
    },
    props: {
        // 編集ID
        edit_id: {
            type: [String, Number],
            require: true
        },
        // 全データ
        template: {
            type: Object,
            default: () => ({}),
            required: true
        },
        // 全エリア定義データ
        areas_config: {
            type: Array,
            default: () => ([]),
            required: true
        },
        // 対象エリア
        edit_area: {
            type: String,
        },
        // 対象エリア名
        area_name: {
            type: String,
        },
        // 連動フラグ
        device_sync: {
            type: Boolean,
            required: true
        },
    },
    components: {
        // 予約日時選択コンポーネント
        'modal-reservation-datetime-editor': modalReservationDatetimeEditor
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
        chromeExtensionMixin,
        userProgressMixin,
        deployReservationCheck,
    ],
    computed: {
        // 手動反映用HTMLがあるか否か
        hasHtmls: function () {
            return (Object.keys(this.area_htmls).length > 0);
        },
        // 手動反映時のメニュータブ
        tabAreas: function () {
            return this.areas_config.filter(area => area.key !== 'header');
        },
        // タブで選択された指定エリアの貼り付けHTML
        htmls: function () {
            if (this.hasHtmls && this.active_tab_area) {
                return this.area_htmls[this.active_tab_area];
            }
            return {};
        }
    },
    emits: ['unedited'],
    methods: {
        // 保存
        save: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/build_store/save', {
                    edit_id: this.edit_id,
                    copy_id: this.$_copyId(),
                    device_sync: this.device_sync,
                    template: this.template,
                });
                if (response.data.status === 'OK') {
                    this.appendFlashMessage({
                        level: 'alert-success',
                        message: '保存が完了しました',
                        autoClear: true
                    }, this.$parent);
                    // エラーメッセージを空にする
                    message = '';
                    this.emitUnedited();
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 反映
        deploy: async function (type) {
            let message = this.exception_error_message;

            // 自動反映＆反映対象に「看板」が含まれている場合
            if (this.isKanbanDeploy(type)) {
                this.alertHeaderNg();
                return;
            }

            try {
                this.$_loading();
                const response = await yahooAxios.post('/build_store/deploy', {
                    type: type,
                    edit_id: this.edit_id,
                    template: this.template,
                    device_sync: this.device_sync,
                    should_publish: this.should_publish,
                    reserve_time: this.reserve_time,
                });
                if (response.data.status === 'OK') {
                    // 手動
                    if (type === 'manual') {
                        this.area_htmls = response.data.area_htmls;
                        this.active_tab_area = this.edit_area;
                    // 自動(拡張機能発動)
                    } else {
                        let actionType = 'build_store';
                        if (this.area_only) {
                            actionType += '_' + this.edit_area;
                            // 連動時、PCトップのみ更新はスマホエリアも更新する
                            if (this.device_sync && this.edit_area === 'freetext') {
                                actionType += '_spfreetext1';
                            }
                        }

                        // 拡張機能パラメータ
                        const extensionParams = {
                            'should_publish': this.should_publish,
                            'reserve_time': this.reserve_time
                        };

                        if (await this.startExtension(actionType, 'deploy_Alert', extensionParams)) {
                            this.close();
                        }
                    }
                    // template更新
                    this.$parent.emitUpdateTemplate(response.data.template);
                    // エラーメッセージを空にする
                    message = '';
                    await this.$nextTick();
                    this.emitUnedited();
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                await this.$root.$refs.yahooAuth.error(e);
                message = '';
            }
            // 一時データ初期化
            this.initData();
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
        // 一時データ初期化
        initData: async function () {
            this.should_publish = true;
            this.reserve_time = null;
        },
        // 拡張機能完了時処理
        finish: async function () {
            this.$_loading();
            // ストアページ作成完了のtaskフラグが立ってない場合はストア構築反映完了ページへ遷移させる
            if (!await this.isDoneTask('opening', 'build_store')) {
                window.location.href = '/build_store/finish';
                return true;
            }
            this.$_unloading();
            bootstrap.Modal.getOrCreateInstance($('#modal_deploy_finish')[0]).show();
        },
        // コピーする
        copy: function (ref) {
            this.$refs[ref][0].select();
            const success = document.execCommand('copy');
            if (!success) {
                return;
            }
            this.appendFlashMessage({
                level: 'alert-success',
                message: 'コピーしました',
                autoClear: true
            }, this.$parent);
        },
        // 今すぐ反映
        deployAtOnce: async function () {
            try {
                // 予約存在をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    if( await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。このまま進むと、予約中の更新も同時に反映されますが、よろしいでしょうか？')) {
                        this.open();
                    }
                    return;
                }
                // 予約なし
                this.open();

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // 反映を予約
        reserveDeploy: async function () {
            try {
                // 予約存在をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    if( await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。今回の更新内容を、こちらの予約へ追加します。')) {
                        this.beforeOpenDelpoyModal(false);
                    }
                    return;
                }
                // 予約なし
                this.$refs.modalReservationDatetimeEditor.open();

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // 前処理後反映ダイアログを開く
        beforeOpenDelpoyModal: function (shouldPublish = true, reserveTime = null) {
            this.should_publish = shouldPublish;
            this.reserve_time = reserveTime;
            this.open();
        },
        // モーダルを閉じた時area_htmlsを初期化
        closed: function () {
            this.area_htmls = [];
        },

        // -------------------------
        //  2023.05 看板ブロック制限への対処
        // -------------------------

        // 自動反映対象に看板が含まれていて、使用できないパーツがあるか否か
        isKanbanDeploy: function (type) {
            if (
                // 自動反映じゃない
                type !== 'auto' ||
                // 反映対象が指定されていて、それが看板でない
                (this.area_only && this.edit_area !== 'header'))
            {
                return false;
            }
            // 看板ブロックに使用できないパーツがないか＆パーツが2個以上ないか
            return this.template.header.parts.some(parts => parts.key !== 'header') ||
                this.template.header.parts.length > 1;
        },
        // 看板ブロックに使用できないパーツがあるアラート
        alertHeaderNg: function () {
            swal('「看板」ブロックに使用できないパーツが登録されているか、パーツが2個以上登録されています。「看板」編集モードに変更して、「使用できません」と書かれたパーツを削除してください。');
        },
        // 手動反映

        // -------------------------
        // emit
        // -------------------------

        // 親コンポーネントのeditedフラグを初期化する
        emitUnedited: function () {
            this.$emit('unedited');
        },

    }
};

